import { ReducersTypes } from "constants/ReducersTypes";

const initialState = {
  list: [],
  totalCount: 0,
  isFetching: false,
  isActioning: false,
  filters: {
    page: 1,
    status: "PENDING",
    type: "LIMIT",
  },
};

const creditApprovals = (state = initialState, action) => {
  switch (action.type) {
    case ReducersTypes.CREDIT_APPROVAL_LIST:
      return { ...state, ...action.payload };
    case ReducersTypes.CREDIT_APPROVAL_FILTERS:
      return { ...state, filters: { ...state.filters, ...action.payload } };
    case ReducersTypes.RESET_CREDIT_APPROVAL_LIST:
      return { ...initialState };
    default:
      return state;
  }
};

export default creditApprovals;
